import { toast } from 'react-toastify';
import { Card } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import { useNavigate } from 'react-router-dom';
import Accordion from 'react-bootstrap/Accordion';
import React, { useEffect, useState } from "react";
import SideBar from "../commanComponents/sidebar/sidebar";

import "./academicLessonDetails.css";
import { clearData } from '../../utils/localStorage';
import { sidebarNavItems, ROUTES } from "../../constant";
import { getAcademicLessonService, saveCourseLessonProgressService } from "../../modules/services";
import TopNavigation from "../commanComponents/topNavigation/topNavigation";
import PrimaryButton from '../commanComponents/primaryButton/primaryButton';


const AcademicLessonDetails = () => {

    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState(false);
    const navigate = useNavigate();
    let { slug, lessonSlug } = useParams();

    useEffect(() => {
        (async () => {
            const responseData = await getAcademicLessonService(lessonSlug, {});
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                setData(responseData.data);
                setIsLoading(false);
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                setIsLoading(false);
            }
            else {
                clearData();
                navigate(ROUTES.LOGIN);
            }
        })();
    }, [lessonSlug]);

    const handlePreviousButton = (slugName) => navigate(ROUTES.ACADEMIC_COURSE_DETAIL + "/" + slug + "/lesson/" + slugName);

    const handleNextButton = (slugName, isSave) => {
        if (isSave) {
            (async () => {
                const responseData = await saveCourseLessonProgressService({
                    "lesson": data.id
                }, {});
                if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                    setIsLoading(false);
                }
                else if (responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                    setIsLoading(false);
                }
                else {
                    clearData();
                    navigate(ROUTES.LOGIN);
                }
            })();
        }
        if (data.next_lesson_slug) { 
            handlePreviousButton(slugName);
        }
        else {
            navigate(ROUTES.ACADEMIC_COURSE_DETAIL + "/" + slug);
        }

       
    }

    return (
        <div className='academic-detail-lesson-container' style={{ display: 'flex' }}>
            <SideBar activeItem={sidebarNavItems.academicCourses} />
            <div className='academic-detail-lesson-side-container'>
                <TopNavigation activeItem={sidebarNavItems.academicCourses} />
                
                <div className='row academic-detail-lesson-filter-container'>
                    <div className='academic-detail-lesson-filter-inner-div'>
                        <PrimaryButton
                            text="Previous"
                            onClick={() => handlePreviousButton(data.previous_lesson_slug)}
                            onlyDisabled={
                                isLoading ?
                                    true
                                    :
                                    data.previous_lesson_slug === null ?
                                        true
                                        :
                                        false
                            }
                            customStyle={{marginRight: "10px"}}
                        />
                        <PrimaryButton
                            text={
                                data.next_lesson_slug ?
                                    <span>Save & Next</span>
                                    :
                                    <span>Submit</span>
                            }
                            onClick={() => handleNextButton(data.next_lesson_slug, true)}
                            isLoading={
                                isLoading ?
                                    true
                                    :
                                    false
                            }
                        />
                    </div>
                </div>
                
                <div>
                    <div className='row'>
                    <div className="col-sm-7">
                            <div className='academic-detail-courses-main-container academic-detail-courses-container-left'>
                                {
                                    isLoading ?
                                    <div className='academic-courses-loader-div'>
                                        <Spinner animation="border" role="status" className='academic-courses-loader'>
                                            <span className="visually-hidden">Loading...</span>
                                        </Spinner>
                                    </div>
                                    :
                                    <h5>{data.name}</h5>
                                }
                                <hr className="academic-detail-courses-border" />
                                {
                                    isLoading ?
                                    <div className='academic-courses-loader-div'>
                                        <Spinner animation="border" role="status" className='academic-courses-loader'>
                                            <span className="visually-hidden">Loading...</span>
                                        </Spinner>
                                    </div>
                                    :
                                    <div dangerouslySetInnerHTML={{ __html: data.content }} />
                                }
                            </div>
                        </div>
                        <div className="col-sm-5">
                            <div className='academic-detail-courses-main-container'>
                                <h5>Table of Content</h5>
                                <hr className="academic-detail-courses-border" />
                                {
                                    isLoading ?
                                    <div className='academic-courses-loader-div'>
                                        <Spinner animation="border" role="status" className='academic-courses-loader'>
                                            <span className="visually-hidden">Loading...</span>
                                        </Spinner>
                                    </div>
                                    :
                                    <Accordion>
                                        {data.chapters.map((chapter, index) => {
                                            return (
                                                <Accordion.Item className='academic-detail-courses-chapter' key={chapter.id} eventKey={index}>
                                                    <Accordion.Header>{chapter.name}</Accordion.Header>
                                                    <Accordion.Body>
                                                        <Accordion>
                                                            {chapter.lessons.map((lesson, index) => { 
                                                                return (
                                                                    <Card key={lesson.id} className='academic-detail-courses-lesson'>
                                                                        <Card.Body>
                                                                            <Card.Text>
                                                                                <div className='row'>
                                                                                    <div className='col-sm'>
                                                                                        {
                                                                                            lesson.is_completed ?
                                                                                                <i className="bi bi-check-circle-fill academic-detail-courses-lesson-tick"></i>
                                                                                                :
                                                                                                <i className="bi bi-circle academic-detail-courses-lesson-tick"></i>
                                                                                        }
                                                                                        <label
                                                                                            onClick={() => handleNextButton(lesson.slug_name, false)}
                                                                                            className='academic-detail-courses-lesson-cursor'
                                                                                        >
                                                                                            {lesson.name}
                                                                                        </label>
                                                                                    </div>
                                                                                    <div className='col-sm-4 academic-detail-courses-lesson-duration'>
                                                                                        <label>{lesson.duration} minutes</label>
                                                                                    </div>
                                                                                </div>
                                                                            </Card.Text>
                                                                        </Card.Body>
                                                                    </Card>
                                                                );
                                                            })}
                                                        </Accordion>
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                            );
                                        })}
                                    </Accordion>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default AcademicLessonDetails;
